import * as React from "react";
import { Component } from "react";
import { Col, ControlLabel, FormControl, FormGroup } from "react-bootstrap";
import LoadingStatus from "src/components/common/LoadingStatus";
import { IBaseState } from "src/interfaces";
import { IElectricityCreditedProps } from "./interfaces";

export default class ElectricityCredited extends Component<IElectricityCreditedProps, IBaseState> {
  public constructor(props: IElectricityCreditedProps) {
    super(props);

    this.state = {
      loading: true,
    };

    this.handleSolarReadDateChanged = this.handleSolarReadDateChanged.bind(this);
    this.handleSolarReadingChanged = this.handleSolarReadingChanged.bind(this);
    this.handlePriorSolarReadDateChanged = this.handlePriorSolarReadDateChanged.bind(this);
    this.handlePriorSolarReadingChanged = this.handlePriorSolarReadingChanged.bind(this);
  }

  public componentDidMount() {
    this.setState({ loading: false });
  }

  public render() {
    if (this.state.loading) {
      return (
        <fieldset>
          <legend>Electricity Credited</legend>
          <LoadingStatus singular={true} width={25} height={25} />
        </fieldset>
      );
    }

    const xsLabelWidthL = 6;
    const xsInputWidthL = 6;
    const smLabelWidthL = 6;
    const smInputWidthL = 6;
    const mdLabelWidthL = 6;
    const mdInputWidthL = 6;

    let readOnly = this.props.match.params.priorId === undefined ? false : true;
    if (this.props.priorDataEditable) {
      readOnly = false;
    }

    return (
      <fieldset className="fieldset-left">
        <legend>Electricity Credited</legend>
        <FormGroup bsSize="small" controlId="solarReadDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Read Date
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.solarReadDate).toISOString().substring(0, 10)}
              onChange={this.handleSolarReadDateChanged}
              readOnly={true}
              tabIndex={-1}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="solarReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.solarReading}
              onChange={this.handleSolarReadingChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorSolarReadDate">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Last Date
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="date"
              value={new Date(this.props.priorSolarReadDate).toISOString().substring(0, 10)}
              readOnly={true}
              tabIndex={-1}
              onChange={this.handlePriorSolarReadDateChanged}
            />
          </Col>
        </FormGroup>
        <FormGroup bsSize="small" controlId="priorSolarReading">
          <Col
            xs={xsLabelWidthL}
            sm={smLabelWidthL}
            md={mdLabelWidthL}
            componentClass={ControlLabel}
          >
            Reading
          </Col>
          <Col xs={xsInputWidthL} sm={smInputWidthL} md={mdInputWidthL}>
            <FormControl
              bsSize="small"
              type="number"
              value={this.props.priorSolarReading}
              readOnly={readOnly}
              tabIndex={readOnly ? -1 : undefined}
              onChange={this.handlePriorSolarReadingChanged}
            />
          </Col>
        </FormGroup>
      </fieldset>
    );
  }

  private handleSolarReadDateChanged(e: any) {
    this.props.solarReadDateChanged(e);
  }
  private handleSolarReadingChanged(e: any) {
    this.props.solarReadingChanged(e);
  }
  private handlePriorSolarReadDateChanged(e: any) {
    this.props.priorSolarReadDateChanged(e);
  }
  private handlePriorSolarReadingChanged(e: any) {
    this.props.priorSolarReadingChanged(e);
  }
}



// WEBPACK FOOTER //
// ./src/components/projects/project/statements/advanced/singlerate/ElectricityCredited.tsx